exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".circle-rect-icon{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-weight:bold;color:#ffffff;cursor:pointer}.circle-rect-icon-holder{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}.circle-rect-icon-holder>i{margin-left:10px;font-size:18px;cursor:pointer}.circle-rect-icon_circle{width:45px;height:45px;border-radius:100%;padding:10px;text-transform:uppercase;font-size:12px;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;z-index:-1}@media only screen and (max-width: 425px){.circle-rect-icon_circle{font-size:10px}}.circle-rect-icon_rect{padding:3px 3px 3px 25px;width:80px;border-radius:0 5px 5px 0;margin-left:-20px;background-color:red;z-index:-10}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/common/treeTableWithSlider/circleRectIcon/CircleRectIcon.style.scss
// module id = 690
// module chunks = 0